import ic_arrow_right from './ic_arrow_right.svg';
import ic_box from './ic_box.svg';
import ic_cards from './ic_cards.svg';
import ic_flash from './ic_flash.svg';
import ic_graphic_discord from './ic_graphic_discord.webp';
import ic_keyboard_arrow_down from './ic_keyboard_arrow_down.svg';
import ic_link from './ic_link.svg';
import ic_minus from './ic_minus.svg';
import ic_ocean from './ic_ocean.svg';
import ic_people from './ic_people.svg';
import ic_plus from './ic_plus.svg';
import ic_search from './ic_search.svg';
import ic_shapes from './ic_shapes.svg';
import ic_status_up from './ic_status_up.svg';
import ic_tag from './ic_tag.svg';
import ic_wave_section from './ic_wave_section.svg';
import ic_wave_section_2 from './ic_wave_section_2.svg';
import ic_x from './ic_x.svg';

export const icons = {
  ic_arrow_right,
  ic_box,
  ic_cards,
  ic_flash,
  ic_graphic_discord: ic_graphic_discord.src,
  ic_keyboard_arrow_down,
  ic_link,
  ic_minus,
  ic_ocean,
  ic_people,
  ic_plus,
  ic_search,
  ic_shapes,
  ic_status_up,
  ic_tag,
  ic_wave_section,
  ic_wave_section_2,
  ic_x,
};

export * from './HighLightHorizontal';
